<script>
  import { GridList } from "creditdesign-svelte-components";
  import SelectedCompany from "../SelectedCompany/index.svelte";

  export let className = "";
  export let companies;
</script>

<div class="{`top12grid ${className}`}">
  <GridList minWidth="200px" gridSpace="var(--s1)">
    {#each companies as companyData}
      <li>
        <SelectedCompany {companyData} />
      </li>
    {/each}
  </GridList>
</div>
